module.exports = __webpack_public_path__ + "img/lab-config.c699d53c.svg";